<template>
    <div id="floorplansHeader" class="bg-white shadow overflow-hidden sm:rounded-lg mb-5">
        <div class="grid grid-cols-6 px-4 py-5 sm:px-6 place-items-center">
            <div class="col-span-6 justify-self-start">
                <div class="align-middle">
                    <h3 class="text-lg leading-6 font-medium text-gray-900">Floorplans ({{ floorplans.length }})</h3>
                </div>
            </div>
        </div>
    </div>

    <div id="floorplansContainer">
        <div v-for="(floorplan, $i) of floorplans" class="bg-white shadow overflow-hidden sm:rounded-lg mb-4">

            <div class="grid grid-cols-2 gap-5">

                <div class="col-span-2 border-t border-gray-200">
                    <dl>
                        <div class="border-b px-4 py-3 grid grid-cols-1">
                            <image-container @image-click="handleImageClick" :item="floorplan" />
                        </div>

                        <div class="border-b px-4 py-3 grid grid-cols-3">
                            <div class="col-span-3 font-bold text-sm">
                                <dt class="font-medium text-gray-500 inline-block">
                                    Floor :
                                </dt>
                                <dd class="text-gray-900 sm:mt-0 sm:col-span-2 inline-block">
                                    {{ floorplan.floor }}
                                </dd>
                            </div>
                        </div>
                    </dl>
                </div>

            </div>
        </div>
    </div>
    <div v-if="!floorplans.length" class="overflow-hidden shadow rounded-lg mb-4">
        <div class="bg-gray-50 px-4 py-5 sm:p-6 text-center">
            <p>There are no floorplans available.</p>
        </div>
    </div>
</template>

<script>
import ImageContainer from "./ImageContainer";

export default {
    name: 'Floorplans',

    components: { ImageContainer },

    props: {
        floorplans: {
            type: Array,
            required: true
        }
    },

    methods: {
        handleImageClick(imageUrl) {
            this.$emit('image-click', imageUrl);
        }
    }
}
</script>

<style scoped>
#floorplansHeader {
    margin-top: 58px;
    left: 0;
    z-index: 1;
}
</style>
